import { observable, action } from "mobx";
import { DeviceDetector } from "@utils";
import { history, SessionStorageProvider } from "@state";
import { getCurrentCulture } from "@utils";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";
import { StorageStateKeysEnum } from "@utils/storage";
import type { RootStore } from "@state/stores/types";
import { androidAppStoreUrl, iOSAppStoreURL } from "@utils/specific/capacitor";

class AppPopupStore {
	@observable isAppPopupVisible = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	get shouldAllowAppInstall() {
		return (
			DeviceDetector.isMobileTheme &&
			!DeviceDetector.isMobileApp &&
			!isCapacitorPlatform() &&
			WEBPACK_CAPACITOR_ENABLED &&
			((DeviceDetector.isIOS && WEBPACK_CAPACITOR_USE_APPLE_STORE) ||
				DeviceDetector.isAndroid)
		);
	}

	get shouldDisplayAppInstall() {
		return (
			!SessionStorageProvider.get("appPopup") &&
			!JSON.parse(
				this.rootStore.localStorageProvider.get(
					StorageStateKeysEnum.MOBILE_APP_POPUP_DISPLAY
				) as string
			) &&
			this.shouldAllowAppInstall
		);
	}

	onInitialize() {
		if (this.shouldDisplayAppInstall) {
			this.isAppPopupVisible = true;
		}
	}

	@action.bound
	hidePopupForSession(isChecked: boolean) {
		if (isChecked) {
			this.dontShowAgain();
		}
		SessionStorageProvider.set("appPopup", "true");
		this.isAppPopupVisible = false;
	}

	@action.bound
	dontShowAgain() {
		this.rootStore.localStorageProvider.set(
			StorageStateKeysEnum.MOBILE_APP_POPUP_DISPLAY,
			"true"
		);
		this.isAppPopupVisible = false;
	}

	redirectToInstallPage = () => {
		if (
			DeviceDetector.isAndroid &&
			WEBPACK_CAPACITOR_SHOULD_REDIRECT_TO_GOOGLE_STORE
		) {
			window.location.href = androidAppStoreUrl;
		} else if (
			DeviceDetector.isIOS &&
			WEBPACK_CAPACITOR_SHOULD_REDIRECT_TO_APPLE_STORE
		) {
			window.location.href = iOSAppStoreURL;
		} else {
			history.push(`/${getCurrentCulture()}/info/install-app`);
		}
	};
}

export default AppPopupStore;
